import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { SuiLabel, SuiContainer, SuiDatePickerNew, ORIGIN_BOTTOM_RIGHT, ORIGIN_TOP_RIGHT } from '@splashthat/sui';

import { containerPaddingXs } from 'common/styles/variables';
import { getFormNode } from 'common/entities/formNode/selectors';
import { DATE_MAX, DATE_MIN } from 'common/entities/formNode/nodeConfig';
import { updateFormNodeConfigValue } from '../../../actions/nodeActions';
import disableWhenLocked from './disableWhenLocked';

const DATE_RANGE_LABEL = 'Available Dates';
const LABEL_FROM = 'From';
const LABEL_TO = 'To';
const BASE_COMPONENT_NAME = 'DateRangeControl';

const PaddedSmallSpacer = styled(SuiContainer)`
    padding: ${containerPaddingXs} 0;
`;

export const DateRangeControlUI = (props) => (
    <React.Fragment>
        <SuiContainer variation="flex-group flex-vertical">
            <SuiDatePickerNew
                fullWidth
                label={LABEL_FROM}
                value={props.dateMin}
                onChange={(event, value) => props.onChangeDateMin(value)}
                disabled={props.disabled}
                anchorOrigin={ORIGIN_TOP_RIGHT} /* so calendar stays in the viewport */
                targetOrigin={ORIGIN_BOTTOM_RIGHT} /* so calendar stays in the viewport */
                data-qa={`${BASE_COMPONENT_NAME}__dateMin`}
                variation={props.error ? 'error' : ''}
            />
            <PaddedSmallSpacer />
            <SuiDatePickerNew
                fullWidth
                label={LABEL_TO}
                value={props.dateMax}
                onChange={(event, value) => props.onChangeDateMax(value)}
                disabled={props.disabled}
                anchorOrigin={ORIGIN_TOP_RIGHT} /* so calendar stays in the viewport */
                targetOrigin={ORIGIN_BOTTOM_RIGHT} /* so calendar stays in the viewport */
                data-qa={`${BASE_COMPONENT_NAME}__dateMax`}
                variation={props.error ? 'error' : ''}
            />
        </SuiContainer>
    </React.Fragment>
);

DateRangeControlUI.propTypes = {
    dateMax: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    dateMin: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    /** disabled is passed when form node editing is locked */
    error: PropTypes.bool,
    disabled: PropTypes.bool.isRequired,
    onChangeDateMax: PropTypes.func.isRequired,
    onChangeDateMin: PropTypes.func.isRequired,
};

DateRangeControlUI.defaultProps = {
    dateMax: null,
    dateMin: null,
    error: false,
};

const DateRangeControlWithLabel = (props) => (
    <React.Fragment>
        <SuiLabel text={DATE_RANGE_LABEL} />
        <DateRangeControlUI {...props} />
    </React.Fragment>
);

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        dateMax: props.formNodeId ? formNode.config.dateMax : null,
        dateMin: props.formNodeId ? formNode.config.dateMin : null,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChangeDateMax: (dateMax) => dispatch(updateFormNodeConfigValue(ownProps.formNodeId, DATE_MAX, dateMax)),
    onChangeDateMin: (dateMin) => dispatch(updateFormNodeConfigValue(ownProps.formNodeId, DATE_MIN, dateMin)),
});

const ConnectedDateRangeControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(DateRangeControlWithLabel));

ConnectedDateRangeControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedDateRangeControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedDateRangeControl;
